<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full">
			<ul class="ul-area">
				<li class="mt-3">
					<vs-radio v-model="status" vs-value="frequencyMinute">{{ $t("TimeWindow.EveryMinute") }}</vs-radio>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="rangeMinute">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.Every") }} </span>
									<vs-select
										autocomplete
										v-model="numberMinute"
										width="60px"
										class="ml-1"
										:disabled="status !== 'rangeMinute'"
										:input-changed="getResultMinute"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in minuteList"
										/>
									</vs-select>
									<span class="ml-1">{{
										($t("TimeWindow.MinuteStartingAtMinute") + " ") | lowerCase
									}}</span>
									<vs-select
										autocomplete
										v-model="numberMinuteTwo"
										width="70px"
										class="ml-1"
										:disabled="status !== 'rangeMinute'"
										:input-changed="getResultMinute"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in minuteNumberList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="choiceMinute">{{
								$t("TimeWindow.SpecificMinute")
							}}</vs-radio>
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-select
										autocomplete
										multiple
										v-model="selectMinute"
										width="100%"
										:disabled="status !== 'choiceMinute'"
										:input-changed="getResultMinute"
										@input="selectMinute.sort()"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in minuteNumberList"
										/>
									</vs-select>
								</div>
							</div>
						</div>
					</div>
				</li>
				<li class="mt-4">
					<div class="vx-row">
						<div class="vx-col w-full">
							<vs-radio v-model="status" vs-value="betweenMinute">
								<div class="form-inline">
									<span>{{ $t("TimeWindow.EveryMinuteBetweenMinute") }} </span>
									<vs-select
										autocomplete
										v-model="rangeMinuteInit"
										width="60px"
										class="ml-1"
										:disabled="status !== 'betweenMinute'"
										:input-changed="getResultMinute"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in minuteNumberList"
										/>
									</vs-select>
									<span class="ml-1">{{ ($t("TimeWindow.And") + " ") | lowerCase }}</span>
									<vs-select
										autocomplete
										v-model="rangeMinuteEnd"
										width="60px"
										class="ml-1"
										:disabled="status !== 'betweenMinute'"
										:input-changed="getResultMinute"
									>
										<vs-select-item
											:key="index"
											:value="option.value"
											:text="option.text"
											v-for="(option, index) in minuteNumberList"
										/>
									</vs-select>
								</div>
							</vs-radio>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "Minute",
	data() {
		return {
			status: "choiceMinute",
			numberMinute: 1,
			rangeMinuteInit: 0,
			rangeMinuteEnd: 0,
			numberMinuteTwo: 0,
			selectMinute: [0],
		};
	},
	props: {
		cronExpressionMinute: {
			type: String,
			default: "",
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getResultMinute() {
			let result = "";
			switch (this.status) {
				case "frequencyMinute":
					result = "*";
					break;
				case "rangeMinute":
					result = `${this.numberMinuteTwo}/${this.numberMinute}`;
					break;
				case "choiceMinute":
					result = `${this.selectMinute.join(",")}`;
					break;
				case "betweenMinute":
					result = `${this.rangeMinuteInit}-${this.rangeMinuteEnd}`;
					break;
			}
			this.$emit("resultMinuteEmit", result);
			return result;
		},
		minuteList() {
			let minute = [];
			for (let i = 1; i <= 60; i++) {
				minute.push({text: i, value: i});
			}
			return minute;
		},
		minuteNumberList() {
			let number = [];
			for (let i = 0; i < 60; i++) {
				number.push({text: i.toString().length > 1 ? `${i}` : `0${i}`, value: i});
			}
			return number;
		},
	},
	mounted() {
		if (
			this.cronExpressionMinute !== " " &&
			this.cronExpressionMinute !== null &&
			this.cronExpressionMinute !== undefined &&
			this.isEdit
		) {
			if (this.cronExpressionMinute.includes("*")) {
				this.status = "frequencyMinute";
			} else if (this.cronExpressionMinute.includes("/")) {
				this.numberMinuteTwo = this.cronExpressionMinute.split("/")[0];
				this.numberMinute = this.cronExpressionMinute.split("/")[1];
				this.status = "rangeMinute";
			} else if (this.cronExpressionMinute.includes("-")) {
				this.rangeMinuteInit = this.cronExpressionMinute.split("-")[0];
				this.rangeMinuteEnd = this.cronExpressionMinute.split("-")[1];
				this.status = "betweenMinute";
			} else {
				if (this.cronExpressionMinute.includes(",")) {
					this.selectMinute = this.cronExpressionMinute.split(",").map((minute) => parseInt(minute));
				} else {
					this.selectMinute = [parseInt(this.cronExpressionMinute)];
				}
				this.status = "choiceMinute";
			}
		}
	},
};
</script>
<style lang="scss">
.form-inline {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-flow: row wrap;
	flex-flow: row wrap;
	-ms-flex-align: center;
	align-items: center;
}
.specific-check {
	display: flex;
	flex-wrap: wrap;
	padding-left: 20px;
}
.check-week {
	padding: 10px 0px 10px 0px;
}
.vs-radio--input + .vs-radio + .vs-radio--label {
	color: #ababab;
	cursor: pointer;
}
.vs-radio--input:checked + .vs-radio + .vs-radio--label {
	color: #000;
}
</style>
